export default function parseFileName(fileName: string) {
  const splitFilename = fileName.split('.');
  const fileExtension = splitFilename.pop();
  const fileNameWithoutExtension = splitFilename.join('.');

  return {fileExtension, fileNameWithoutExtension};
}
